import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconCheck } from '@change-corgi/design-system-legacy/icons';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';
import { Text } from '@change-corgi/design-system-legacy/typography';

export const useReportAbuseConfirmModal = createModalHook({
	name: 'ReportAbuseConfirmModal',
	title: () => <Translate value="fe.components.petition_report_abuse.form_title" />,
	body: function ReportAbuseConfirmModalBody() {
		return (
			<>
				<Icon icon={iconCheck} size="m" mr={8} sx={{ transform: 'translateY(2px)' }} />
				<Text>
					<Translate value="fe.components.petition_report_abuse.form_confirmation" />
				</Text>
			</>
		);
	},
});
